import { useEffect, useState } from "react";

const GlobalLayout = ({ children }) => {
	const [menu, setMenu] = useState([]);
	const [isOpen, setIsOpen] = useState(false);

	const [isShowMobily, setIsShowMobily] = useState(false);

	useEffect(() => {
		// Handler to call on window resize
		function handleResize() {
			// Set window width/height to state
			if (window.innerWidth <= 780) {
				setIsShowMobily(true);
			} else {
				setIsShowMobily(false);
			}
		}
		// Add event listener
		window.addEventListener("resize", handleResize);
		// Call handler right away so state gets updated with initial window size
		handleResize();
		// Remove event listener on cleanup
		return () => window.removeEventListener("resize", handleResize);
	}, []);
	useEffect(() => {
		const callMenuFromSite = async () => {
			try {
				// const response = await fetch(process.env.REACT_APP_API_KEY + "/public/Content/QueryHeaderMenue?appiid=8", {
				//   method: "GET",
				//   headers: {
				//     Accept: "application/json",
				//     "Content-Type": "application/json",
				//   },
				// });
				// let websiteMenu = await response?.json();
				// websiteMenu = websiteMenu?.Result?.map((item) => {
				//   if (item.stR_MenueLinkURL.includes("https")) {
				//     return { ...item };
				//   } else {
				//     return { ...item, stR_MenueLinkURL: "https://www.aptel.ir" + item.stR_MenueLinkURL };
				//   }
				// });
				// setMenu(websiteMenu);
			} catch (error) {
				console.error(error);
			}
		};
		if (!isShowMobily) {
			callMenuFromSite();
		}
	}, []);
	return (
		<>
			<div className={`global_layout ${isOpen ? "open" : ""}`}>
				<div className="global_menu_holder">
					<div className="global_top_menu">
						<div className="global_wrapper">
							<div className="golbal_row_menu">
								<div className="global_right_item">
									پشتیبانی مشترکین: <a href="tel:09991000000">09991000000</a>
								</div>
								<div className="global_left_item">
									<ul>
										<li>
											{/* <a href="#/">پوشش</a> */}
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="global_menu">
						<div className="global_wrapper">
							<button className="global_hamburger" onClick={() => setIsOpen((prev) => !prev)} type="button">
								<span></span>
								<span></span>
								<span></span>
							</button>
							<div className="brand-logo">
								<a href="https://www.aptel.ir">
									<img src={process.env.PUBLIC_URL + process.env.REACT_APP_ROOT_PATH_FILE + "/assets/images/logo.png"} />
								</a>
							</div>

							<div className="global_navigator">
								<div className="global_cover_menu">
									<ul>
										{menu?.map((item, key) => (
											<li key={key}>
												<a href={item?.stR_MenueLinkURL}>{item?.stR_MenueName}</a>
											</li>
										))}
									</ul>
								</div>
							</div>
							<div className="global_action_header">
								{/* <a href="https://my.aptel.ir/" className="global_myaptel">
                  آپتـــل ‌من
                </a> */}
							</div>
						</div>
					</div>
				</div>
				{!isShowMobily ? <div className="global_container">{children}</div> : <div className="global_mobile">{children}</div>}

				<footer className="global_footer">
					<div className="global_wrapper">
						<div className="global_row_title">
							{/*<div className="global_item">
                <ul>
                  <li className="title">
                    <strong>محصولات و خدمات</strong>
                  </li>
                  <li>
                    <a href="https://dcstore.aptel.ir/packages">خرید بسته اینترنتی</a>
                  </li>
                  <li>
                    <a href="https://dcstore.aptel.ir/directcharge">خرید شارژ</a>
                  </li>

                  <li>
                    <a href="https://simcardstore.aptel.ir/html/bundle-simcard.html">خرید و ثبت نام سیم‌کارت</a>
                  </li>
                  <li>
                    <a href="https://www.aptel.ir/organization-aptel">خدمات سازمانی</a>
                  </li>
                </ul>
              </div>
              <div className="global_item">
                <ul>
                  <li className="title">
                    <strong>دسترسی کوتاه</strong>
                  </li>
                  <li>
                    <a href="https://www.aptel.ir/WebSite/ApTel/News/NewsIndex">اخبار</a>
                  </li>
                  <li>
                    <a href="https://www.aptel.ir/WebSite/ApTel/Tatiffs/TariffsIndex">تعرفه‌ها</a>
                  </li>
                  <li>
                    <a href="https://www.aptel.ir/ussd-code-aptel">کدهای دستوری</a>
                  </li>
                  <li>
                    <a href="https://www.aptel.ir/WebSite/ApTel/Dealer/RegisterDealer">همکاری با ما</a>
                  </li>
                  <li>
                    <a href="https://www.aptel.ir/WebSite/Aptel/CareerOpportunities/CareerOpportunitiesIndex?view=CareerOpportunities">
                      فرصت‌های شغلی
                    </a>
                  </li>
                  <li>
                    <a href="https://www.aptel.ir/speedtest-aptel">تست سرعت</a>
                  </li>
                </ul>
              </div>
              <div className="global_item">
                <ul>
                  <li className="title">
                    <strong>نمایندگی</strong>
                  </li>
                  <li>
                    <a href="https://www.aptel.ir/WebSite/ApTel/Dealer/RegisterDealer">فهرست نمایندگی‌ها</a>
                  </li>
                  <li>
                    <a href="https://www.aptel.ir/WebSite/ApTel/FAQ/FAQIndex">سوالات متداول</a>
                  </li>
                  <li>
                    <a href="https://www.aptel.ir/policy-aptel">شرایط و ضوابط</a>
                  </li>
                  <li>
                    <a href="https://www.aptel.ir/coverage-aptel">مناطق تحت پوشش</a>
                  </li>
                </ul>
              </div>
              <div className="global_item">
                <ul>
                  <li className="title">
                    <strong>تماس با ما</strong>
                  </li>
                  <li>
                    تماس از خطوط آپتل : <a href="tel:100">100</a>
                  </li>
                  <li>
                    تماس از سایر خطوط : <a href="tel:09991000000">09991000000</a>
                  </li>
                </ul>
              </div>*/}
						</div>
						<div className="global_footer_social">
							<div className="global_social">
								<ul>
									<li>
										<a href="#/">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												enableBackground="new 0 0 75 75"
												width="75"
												height="75"
												viewBox="0 0 81 81"
												fill="none"
												preserveAspectRatio="none">
												<g filter="url(#filter0_d_11686_93452)">
													<g filter="url(#filter1_d_11686_93452)">
														<circle cx="40.3661" cy="28.3661" r="16.3661" fill="url(#paint0_linear_11686_93452)"></circle>
													</g>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M43.2518 21.2266H37.4848C35.1411 21.2266 33.2344 23.1333 33.2344 25.477V31.2439C33.2344 33.5877 35.1411 35.4944 37.4848 35.4944H43.2518C45.5955 35.4944 47.5022 33.5877 47.5022 31.2439V25.477C47.5022 23.1333 45.5955 21.2266 43.2518 21.2266ZM46.069 31.2461C46.069 32.8008 44.8087 34.0612 43.2539 34.0612H37.487C35.9323 34.0612 34.6719 32.8008 34.6719 31.2461V25.4792C34.6719 23.9244 35.9323 22.6641 37.487 22.6641H43.2539C44.8087 22.6641 46.069 23.9244 46.069 25.4792V31.2461ZM36.6797 28.362C36.6797 26.3273 38.3351 24.6719 40.3699 24.6719C42.4046 24.6719 44.06 26.3273 44.06 28.362C44.06 30.3968 42.4046 32.0522 40.3699 32.0522C38.3351 32.0522 36.6797 30.3968 36.6797 28.362ZM40.3642 30.6112C39.1189 30.6112 38.1094 29.6017 38.1094 28.3564C38.1094 27.1111 39.1189 26.1016 40.3642 26.1016C41.6095 26.1016 42.619 27.1111 42.619 28.3564C42.619 29.6017 41.6095 30.6112 40.3642 30.6112ZM44.0639 25.581C44.5523 25.581 44.9482 25.1851 44.9482 24.6967C44.9482 24.2084 44.5523 23.8125 44.0639 23.8125C43.5756 23.8125 43.1797 24.2084 43.1797 24.6967C43.1797 25.1851 43.5756 25.581 44.0639 25.581Z"
														fill="white"></path>
												</g>
												<defs>
													<filter
														id="filter0_d_11686_93452"
														x="0"
														y="0"
														width="80.7324"
														height="80.7324"
														filterUnits="userSpaceOnUse"
														colorInterpolationFilters="sRGB">
														<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
														<feColorMatrix
															in="SourceAlpha"
															type="matrix"
															values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
															result="hardAlpha"></feColorMatrix>
														<feOffset dy="12"></feOffset>
														<feGaussianBlur stdDeviation="12"></feGaussianBlur>
														<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
														<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11686_93452"></feBlend>
														<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11686_93452" result="shape"></feBlend>
													</filter>
													<filter
														id="filter1_d_11686_93452"
														x="16"
														y="8"
														width="48.7324"
														height="48.7324"
														filterUnits="userSpaceOnUse"
														colorInterpolationFilters="sRGB">
														<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
														<feColorMatrix
															in="SourceAlpha"
															type="matrix"
															values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
															result="hardAlpha"></feColorMatrix>
														<feOffset dy="4"></feOffset>
														<feGaussianBlur stdDeviation="4"></feGaussianBlur>
														<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
														<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11686_93452"></feBlend>
														<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11686_93452" result="shape"></feBlend>
													</filter>
													<linearGradient
														id="paint0_linear_11686_93452"
														x1="24.1094"
														y1="11.9453"
														x2="24"
														y2="44.6775"
														gradientUnits="userSpaceOnUse">
														<stop stopColor="#7024C4"></stop>
														<stop offset="0.415461" stopColor="#C21975"></stop>
														<stop offset="0.702206" stopColor="#C74C4D"></stop>
														<stop offset="1" stopColor="#E09B3D"></stop>
													</linearGradient>
												</defs>
											</svg>
										</a>
									</li>
									<li>
										<a href="#/">
											<svg xmlns="http://www.w3.org/2000/svg" width="75" height="75" viewBox="0 0 81 81" fill="none">
												<g filter="url(#filter0_d_11686_93445)">
													<circle cx="40.3661" cy="28.3661" r="16.3661" fill="#007AB7" />
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M37.1167 25.9766H34.6797V33.825H37.1167V25.9766ZM37.3187 23.4936C37.3187 22.7133 36.6846 22.0781 35.9054 22.0781C35.1218 22.0781 34.4922 22.7133 34.4922 23.4936C34.4922 24.2739 35.1218 24.909 35.9054 24.909C36.6846 24.909 37.3187 24.2739 37.3187 23.4936ZM40.9812 25.9796H38.653V33.8281H41.0854V29.9447C41.0854 28.9239 41.2757 27.9304 42.544 27.9304C43.7942 27.9304 43.8077 29.1008 43.8077 30.0127V33.8281H46.2402V29.5273C46.2402 27.4132 45.7827 25.7891 43.3185 25.7891C42.1318 25.7891 41.3391 26.4378 41.0129 27.0548H40.9812V25.9796Z"
														fill="white"
													/>
												</g>
												<defs>
													<filter
														id="filter0_d_11686_93445"
														x="0"
														y="0"
														width="80.7324"
														height="80.7324"
														filterUnits="userSpaceOnUse"
														colorInterpolationFilters="sRGB">
														<feFlood floodOpacity="0" result="BackgroundImageFix" />
														<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
														<feOffset dy="12" />
														<feGaussianBlur stdDeviation="12" />
														<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
														<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11686_93445" />
														<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11686_93445" result="shape" />
													</filter>
												</defs>
											</svg>
										</a>
									</li>
									<li>
										<a href="#/">
											<svg xmlns="http://www.w3.org/2000/svg" width="75" height="75" viewBox="0 0 81 81" fill="none">
												<g filter="url(#filter0_d_11686_93460)">
													<circle cx="40.3661" cy="28.3661" r="16.3661" fill="#3D5A96" />
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M41.4721 35.077H38.4954V28.7359H37.0078V26.2923H38.4954V24.8265C38.4954 22.8344 39.3353 21.6484 41.7215 21.6484H43.708V24.092H42.4668C41.5376 24.092 41.4758 24.4331 41.4758 25.0705L41.4721 26.2923H43.7221L43.4585 28.7359H41.4721V35.077Z"
														fill="white"
													/>
												</g>
												<defs>
													<filter
														id="filter0_d_11686_93460"
														x="0"
														y="0"
														width="80.7324"
														height="80.7324"
														filterUnits="userSpaceOnUse"
														colorInterpolationFilters="sRGB">
														<feFlood floodOpacity="0" result="BackgroundImageFix" />
														<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
														<feOffset dy="12" />
														<feGaussianBlur stdDeviation="12" />
														<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
														<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11686_93460" />
														<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11686_93460" result="shape" />
													</filter>
												</defs>
											</svg>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="global_footer_bottom">
						<p>
							کلیه حقوق این وب سایت به شرکت نگین‌ارتباطات‌آوا تعلق دارد.دارای مجوز رسمی از سازمان تنظیم مقررات و ارتباطات رادیویی به شماره پروانه
							<span dir="ltr">۱۰۰-۱۰۰-۱۲</span>
						</p>
					</div>
				</footer>
			</div>
		</>
	);
};

export default GlobalLayout;
